const request = {
    invalid_input: 'La entrada no es válida. {{detalles}}',
    general: 'Ocurrió un error en la solicitud.',
    range_not_satisfiable: 'El rango no es satisfactorio.',
    feature_not_supported: 'Esta función no es compatible con el entorno actual.',
};
export default Object.freeze(request);
